import { Observable } from 'rxjs/internal/Observable';
import { APIService } from '@app/_services/api.service';
import { API_PATH } from '@app/app.constants';

export class AppConfigsService {
    constructor(private api: APIService) {}

    updateNotificationsConfig(data): Observable<any> {
        const { userId, notificationType, status } = data;
        const url = `${API_PATH.app_configs.update_notifications_config}/${userId}/${notificationType}/${status}/`;
        return this.api.get(url);
    }

    getCurrentNotificationsConfig(): Observable<any> {
        return this.api.get(`${API_PATH.app_configs.current_notifications_config}`);
    }
}
